/*
 *
 * HiddenVariables selectors
 *
 */

import { get } from 'lodash';
import { createSelector } from 'reselect';

/**
 * Direct selector to the HiddenVariables state domain
 */
const selectHiddenVariablesDomain = (state) =>
  get(state, 'hiddenVariables', []);

/**
 * Default selector used by HiddenVariables
 */

const makeSelectHiddenVariables = createSelector(
  selectHiddenVariablesDomain,
  (substate) => substate,
);

const makeSelectNonEmptyHiddenVariables = createSelector(
  makeSelectHiddenVariables,
  (hiddenVariable) => hiddenVariable.filter(({ values }) => values.length > 0),
);

const makeSelectHiddenVariablesErrors = createSelector(
  makeSelectHiddenVariables,
  (hiddenVariable) => {
    const errors = [];
    hiddenVariable.forEach(({ refId, values }) => {
      if (values.length === 0) {
        errors.push({
          refId,
          errors: {
            missingValues: true,
          },
        });
      }
    });
    return errors;
  },
);

const makeSelectHasHiddenVariablesError = createSelector(
  makeSelectHiddenVariablesErrors,
  (errors) => errors.length > 0,
);

export {
  makeSelectHiddenVariables,
  makeSelectNonEmptyHiddenVariables,
  makeSelectHiddenVariablesErrors,
  makeSelectHasHiddenVariablesError,
};
